import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DictionaryService } from 'src/app/core/service/dictionary.service';

@Injectable({
    providedIn: 'root'
})
export class DictionaryValidators
{
    constructor(private dictionaryService: DictionaryService) { }

    public validateCodeSetNameUnique(control: UntypedFormControl): any
    {
        return new Promise(resolve =>
        {
            this.dictionaryService.existsCodeSetName(control.value).subscribe({
                next: (response) =>
                {
                    if (response)
                    {
                        resolve({ nameExists: true });
                    }
                    else
                    {
                        resolve(null);
                    }
                }
            });
        });
    }

    public validateCodeUnique(codeSetId: number, code: UntypedFormControl, codeSystem: UntypedFormControl, initialCode: string, initialCodeSystem: string): any
    {
        return new Promise(resolve =>
        {
            if (code && codeSystem && (initialCode !== code.value || initialCodeSystem !== codeSystem.value))
            {
                this.dictionaryService.existsCode(codeSetId, code.value, codeSystem.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ codeExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
